import React, { useState, useEffect } from 'react';
import { Card, Row, Col, Input, Button, Form, FormGroup, Label, Modal, ModalBody } from 'reactstrap';
import { FaPlus, FaCheck, FaTrash, FaArrowLeft } from 'react-icons/fa';
import { useNavigate, useParams } from 'react-router-dom';
import LoadingOverlay from "react-loading-overlay-ts";
import DNALoader from "../../../components/Loaders/DnaLoader";
import Alerts from "../../../components/Alerts/alerts";
import DashboardService from "../dashboard.service";
import AuthService from "../../Authentication/auth.service";
import { useTranslation } from 'react-i18next';
import moment from 'moment';

const OrderConfirmationModal = ({ isOpen, toggle, orderId }) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} centered className="order-confirmation-modal">
      <ModalBody className="text-center p-4">
        <div className="confirmation-icon mb-3">
          <FaCheck size={24} color="#fff" />
        </div>
        <h4 className="mb-2">Order Items returned Requested Successfully</h4>
        <h2 className="order-id mb-0">ID# {orderId}</h2>
      </ModalBody>
    </Modal>
  );
};

const EditRfq = () => {
  const [items, setItems] = useState([]);
  const [categories, setCategories] = useState([]);
  const [categoryItems, setCategoryItems] = useState({});
  const [modalOpen, setModalOpen] = useState(false);
  const [orderId, setOrderId] = useState('');
  const [RfqDetails, setRFQDetails] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const { id } = useParams();
  const [userInfo, setUserInfo] = useState(JSON.parse(localStorage.getItem('user')));
  const [returnReason, setReturnReason] = useState('');

  useEffect(() => {
    fetchCategories();
    fetchRfqDetails();
  }, []);

  const fetchCategories = async () => {
    setLoading(true);
    try {
      let offset = 0;
      let limit = 1000;
      let business_id = []
      const response = await DashboardService.getAllCategories(offset, limit, business_id);
      if (response.data.message === "Unauthorized") {
        AuthService.logout();
        navigate("/login");
      } else {
        setCategories(response.data.data);
      }
    } catch (error) {
      Alerts.swalErrorAlert(t("Error fetching categories"));
    }
    setLoading(false);
  };

  const fetchRfqDetails = async () => {
    setLoading(true);
    try {
      const payload = {
        functionName: "GetRFQDetails",
        postData: {
          _id: id,
        }
      }
      const response = await DashboardService.GetRFQDetails(payload);
      if (response.data.status) {
        const rfqData = response.data.data[0];
        setRFQDetails(rfqData);
        setReturnReason(rfqData?.return_reason || '')
        setItems(rfqData.items);
        setOrderId(rfqData.rfq_id);
        // Fetch items for each category
        rfqData.items.forEach(item => fetchItemsForCategory(item?.category));
      } else {
        Alerts.swalErrorAlert(response.data.message || t("Failed to fetch Order details"));
      }
    } catch (error) {
      Alerts.swalErrorAlert(t("An error occurred while fetching Order details"));
    }
    setLoading(false);
  };

  const fetchItemsForCategory = async (categoryId) => {
    try {
      const getData = {
        functionName: "GetItems",
        postData: {
          sort: { _id: -1 },
          offset: 0,
          limit: 1000,
          filter: { category: categoryId },
          business: []
        },
      };
      const response = await DashboardService.getAllItems(getData);
      if (response.data.message === "Unauthorized") {
        AuthService.logout();
        navigate("/login");
      } else {
        setCategoryItems(prevItems => ({
          ...prevItems,
          [categoryId]: response.data.data
        }));
      }
    } catch (error) {
      Alerts.swalErrorAlert(t("Error fetching items"));
    }
  };

  const handleAddItem = () => {
    setItems([...items, { category: '', item: '', quantity: 1 }]);
  };

  const handleItemChange = (itemIndex, batchIndex, value) => {
    const newItems = [...items];
    newItems[itemIndex].selectedBatches[batchIndex].returned_quantity = parseInt(value);
    setItems(newItems);
  };

  const handleRemoveItem = (index) => {
    const newItems = items.filter((_, i) => i !== index);
    setItems(newItems);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    if (!returnReason.trim()) {
      Alerts.swalErrorAlert(t("Please provide a reason for return"));
      setLoading(false);
      return;
    }

    try {
      const rfqData = {
        _id: id,
        items: (() => {
          for (const item of items) {
            for (const batch of item.selectedBatches) {
              if (!batch.returned_quantity || batch.returned_quantity === 0) {
                //iph todo: 47
                //console.log("Returned quantity must be greater than 0 for all batches")
                Alerts.swalErrorAlert(t("Returned quantity must be greater than 0 for all batches"));
                setLoading(false);
                return;
              }
            }
          }
          return items.map(item => ({
            category: item.category,
            item: item.item,
            selectedBatches: item.selectedBatches.map(batch => ({
              batchId: batch.batchId,
              returned_quantity: batch.returned_quantity
            }))
          }));
        })(),
        user_id: userInfo._id,
        return_reason: returnReason
      };
      const response = await DashboardService.ReturnRFQ(rfqData);
      if (response.data.status) {
        setModalOpen(true);
      } else {
        Alerts.swalErrorAlert(response.data.message || t("Failed to update Order"));
      }
    } catch (error) {
      Alerts.swalErrorAlert(t("Failed to return (Add proper quantity)"));
    } finally {
      setLoading(false);
    }
  };





  return (
    <div className="app-main__outer">
      <div className="container mt-4">
        <div className="header">
          <Button color="link" className="p-0 text-decoration-none" onClick={() => navigate(-1)}>
            <FaArrowLeft className="me-2" />
            <span className="text-dark fw-bold">{t("Orders")}</span>
          </Button>
          <div className="actions">
            {RfqDetails?.return_status ? RfqDetails?.return_status === "pending" ? (
              <>
                <button className="pending-button">{t("Pending")}</button>
                {/* <button onClick={openPopup} className="accept-button">{t("Disapprove")}</button> */}
              </>
            ) : RfqDetails?.return_status === "rejected" ? (
              <button className="rejected-button">{t("Items Not Returned")}</button>
            ) : RfqDetails?.return_status === "accepted" ? (
              <button className="accept-button">{t("Items Returned")}</button>
            ) : (
              <button disabled className="pending-button">{t("Pending")}</button>
            )
              :
              <button disabled className="pending-button">{t("Not Requested Yet")}</button>
            }
          </div>
        </div>
        <Card className="rfq-card">
          <div className="p-4">
            <h4 className="mb-4 fw-bold">{t("Return Order Items")} #{orderId}</h4>
            <Form onSubmit={handleSubmit}>
              <LoadingOverlay active={loading} spinner={<DNALoader />}>
                <FormGroup className="mb-3">
                  <Label for="returnReason">{t("Reason for Return")}</Label>
                  <Input
                    type="textarea"
                    name="returnReason"
                    id="returnReason"
                    disabled={RfqDetails?.return_status === "accepted"}
                    style={{ backgroundColor: "white" }}
                    defaultValue={RfqDetails?.return_reason || returnReason}
                    onChange={(e) => setReturnReason(e.target.value)}
                    placeholder={t("Please provide a reason for returning the items")}
                    rows="3"
                    required
                  />
                </FormGroup>
                {RfqDetails?.admin_rejected_reason &&
                  <FormGroup className="mb-3">
                    <Label for="returnReason">{t("Admin Rejection Reason")}</Label>
                    <Input
                      type="textarea"
                      name="returnReason"
                      id="returnReason"
                      disabled
                      style={{ backgroundColor: "white" }}
                      defaultValue={RfqDetails?.admin_rejected_reason}
                      // onChange={(e) => setRejectionReason(e.target.value)}
                      placeholder={t("Reason provided by admin for not returning the items")}
                      rows="3"
                      required
                    />
                  </FormGroup>
                }
                <div className="item-list mb-3">
                  <Row className="mb-2 text-muted">
                    <Col md={2}>{t("Item(s)")}</Col>
                    <Col md={2}>{t("Batch")}</Col>
                    <Col md={2}>{t("Expiry")}</Col>
                    <Col md={2}>{t("Order Quantity")}</Col>
                    <Col md={2}>{t("Returned Quantity")}</Col>
                  </Row>
                  {items.map((item, itemIndex) => (
                    item?.selectedBatches.map((batch, batchIndex) => (
                      <Row key={`${itemIndex}-${batchIndex}`} className="mb-2 align-items-center">
                        <Col md={2}>{item?.itemDetails?.item_name}</Col>
                        <Col md={2}>{batch?.batch_number}</Col>
                        <Col md={2}>{batch?.expiry ? moment(batch?.expiry).format("DD-MM-YYYY") : ''}</Col>
                        <Col md={2}>{batch?.quantity}</Col>
                        <Col md={2}>
                          <Input
                            type="number"
                            min="1"
                            max={batch.quantity}
                            value={batch.returned_quantity || ''}
                            style={{ backgroundColor: 'white' }}
                            readOnly={RfqDetails?.return_status && RfqDetails?.return_status !== "pending" && RfqDetails?.return_status !== "rejected"}
                            onChange={(e) => {
                              const value = parseInt(e.target.value, 10);
                              if (value > 0 && value <= batch.quantity) {
                                handleItemChange(itemIndex, batchIndex, value);
                              } else {
                                Alerts.swalErrorAlert(t("Returned quantity must be greater than 0 and less than or equal to the batch quantity"));
                              }
                            }}
                            className="return-quantity-input"
                          />
                          {/* <Input
                            type="number"
                            min="0"
                            max={batch?.quantity}
                            value={batch?.returned_quantity || ''}
                            onChange={(e) => handleItemChange(itemIndex, batchIndex, e.target.value)}
                          /> */}
                        </Col>
                      </Row>
                    ))
                  ))}
                </div>
                {RfqDetails?.return_status ? RfqDetails?.return_status === "pending" || RfqDetails?.return_status === "rejected" &&
                  <div className="d-flex">
                    <Button type="submit" color="primary" className="px-3">
                      <FaCheck className="me-2" /> {t("Return Items")}
                    </Button>
                  </div>
                  :
                  <div className="d-flex">
                    <Button type="submit" color="primary" className="px-3">
                      <FaCheck className="me-2" /> {t("Return Items")}
                    </Button>
                  </div>
                }
              </LoadingOverlay>
            </Form>
          </div>
        </Card>
        <OrderConfirmationModal isOpen={modalOpen} toggle={() => { setModalOpen(!modalOpen); navigate(-1); }} orderId={orderId} />
      </div>
      <style>{`
        .app-main__outer {
          background-color: #f8f9fa;
          min-height: 100vh;
          padding-top: 20px;
        }
        .rfq-card {
          border-radius: 10px;
          box-shadow: 0 2px 10px rgba(0,0,0,0.05);
          border: none;
        }
        .form-select, .form-control {
          border-color: #e0e0e0;
          border-radius: 5px;
          padding: 10px;
        }
        .btn-light {
          background-color: #ffffff;
          border-color: #e0e0e0;
          color: #333;
        }
        .header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 20px;
        }

        .reject-button, .rejected-button {
          background-color: #ffdddd;
          color: #d9534f;
          border: 1px solid #d9534f;
        }
        .accept-button, .accepted-button {
          background-color: #dff0d8;
          color: #5cb85c;
          border: 1px solid #5cb85c;
        }
        .pay-now-button {
          background-color: #5bc0de;
          color: white;
          border: 1px solid #46b8da;
        }
        .processing-button {
          background-color: #fcf8e3;
          color: #8a6d3b;
          border: 1px solid #faebcc;
        }
        .in-transit-button {
          background-color: #d9edf7;
          color: #31708f;
          border: 1px solid #bce8f1;
        }
        .delivered-button {
          background-color: #dff0d8;
          color: #3c763d;
          border: 1px solid #d6e9c6;
        }
        .pending-button {
          background-color: #f5f5f5;
          color: #777;
          border: 1px solid #ddd;
        }
        button {
          padding: 8px 16px;
          border-radius: 5px;
          cursor: pointer;
          font-weight: bold;
          transition: all 0.3s ease;
        }
        button:hover:not(:disabled) {
          opacity: 0.8;
        }
        button:disabled {
          cursor: not-allowed;
          opacity: 0.6;
        }
        .btn-primary {
          background-color: #3D607A;
          border-color: #3D607A;
        }
        .text-muted {
          color: #6c757d !important;
        }
        h4, h5 {
          color: #333;
        }
        .item-list {
          border-top: 1px solid #e0e0e0;
          border-bottom: 1px solid #e0e0e0;
          padding: 20px 0;
        }
        .order-confirmation-modal {
          display: flex !important;
          align-items: center;
          justify-content: center;
        }
      
      
        .order-confirmation-modal .modal-content {
          border-radius: 20px;
          border: none;
          box-shadow: 0 5px 15px rgba(0,0,0,0.1);
        }
      
        .order-confirmation-modal .modal-body {
          padding: 2rem;
        }
      
        .confirmation-icon {
          width: 60px;
          height: 60px;
          background-color: #4CAF50;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto;
        }
      
        .order-id {
          font-size: 2rem;
          font-weight: bold;
        }
      `}</style>
    </div>
  );
};

export default EditRfq;
